import { SETUP_MODULES_URL } from "../../constants/Urls";
import { uniqBy } from 'lodash'

import Vue from 'vue'
import Vuetify from '@/plugins/vuetify'


const searchInitialIndex = (module) => {
  let i = module.contents.length - 1;
  while (i > 0) {
    
    if (!module.contents[i].finished_at && module.contents[i-1].finished_at) {
      // Serviços não mobile
      if (!Vuetify.framework.breakpoint.mobile) {
        return i;
      }
      // Serviços mobile, devem ter active tab sem ser do tiposcorm
      else {
        let u = i;
        while (u < module.contents.length && !module.contents[u].finished_at) {
          if (module.contents[u].type != 'scorm'){
            return u;
          }
          u++;
        }
      }	
    }
    i--;
  }
  return 0;
}

export default {
  state: {
    isLoadingModule: false,
    isFinishingModule: false,
    isLoadingModules: false,
    loadingMessage: 'Carregando ...',
    loadedSelectionModules: false,
    current: null,
    list: [],
    view_dark: false,
    showModalModule: false,
    selection: [],
    synced_subtopics: false,
    show_module_menu_mobile: false,
    accessing_content: false
  },

  actions: {
    syncSubtopicsWeights({ state },) {
      state.isLoadingModules = true;
      state.loadingMessage = 'Carregando suas notas ...';
      return axios.post('/api/v1/student/module/sync-subtopics')
        .then((r)=>{
          state.synced_subtopics = r.data.data.synced_subtopics;
          state.loadingMessage = 'Notas carregadas ...';
          return r;
        })
        .finally(()=> state.isLoadingModule = false)
    },

    getModule({ commit, state}, { id }) {
      state.isLoadingModule = true;
      return axios.get(`/api/v1/student/module/${id}`)
        .then(response => {

          const { data : { data: module }} = response
          
          let activeTab = searchInitialIndex(module);
    
          commit("SET_MODULE", {
            ...module,
            activeTab,
          })

          commit("SET_LAST_ACCESS_MODULE", response.data.data);

          return response;

        })
        .finally(() => state.isLoadingModule = false);
    },
    getSelectionModules({ commit, state, getters }) {
      state.loadingMessage = 'Carregando módulos personalizados ...';
      state.isLoadingModules = true;
      return axios.get(`/api/v1/student/module/select?&cycle_config_id=${getters.selectedCycle.id}`)
        .then(r => {
          state.loadingMessage = 'Módulos carregados.';
          commit("SET_SELECTION_MODULES", r.data.data.map(m => {
            m.selected = false;
            return m
          }));
          return r;
        })
        .catch(() => {
          Vue.notify({
            type: 'error',
            text: `Erro ao carregar módulos.`,
            duration: 10000
          })
      })
        .finally(() => {
          state.isLoadingModules = false;
          state.loadedSelectionModules = true;
        })
    },
    setupModules({ state }, {modules, cycle_config_id, trail_id, blocks}) {
      state.isLoadingModules = true;
      return axios
      .post(SETUP_MODULES_URL, {
        modules,
        cycle_config_id,
        trail_id,
        blocks,
      })
      .then(()=>{
        Vue.notify({
          type: 'success',
          text: 'Módulos selecionados com sucesso.',
          duration: 10000
        })
      })
      .catch(errorRequest => {

        let message;

        if(errorRequest.response){
          const errors = errorRequest.response.data.errors;
          for (let index in errors) {
            if(!message) {
              message = errors[index][0]
            }
            errors[index] = errors[index][0];
          }
          message = message ? message : "Erro de validação";
      } else {
          message = errorRequest
      }
      Vue.notify({
        type: 'error',
        text: message,
        duration: 10000
      })
      })
      .finally(() => {
        state.isLoadingModules = false;
      })
    },
    getModulesForRevision({commit, state}, {moduleType: moduleType}) {
      state.isLoadingModules = true;
      return axios.get('/api/v1/student/module/revision?module_type=' + moduleType)
        .then(response => {
          const {data: {data : module }} = response;
          commit("SET_MODULE", module);
          commit("SHOW_MODAL_MODULE", true);
          commit("SET_LAST_ACCESS_MODULE", module);
          return response;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          state.isLoadingModules = false;
        })
    },
    async saveContentProgress({ state, getters }, { content_id, seconds_duration, seconds_watched }) {
      return axios.post(`/api/v1/student/content/progress/${content_id}`, {
          seconds_duration: Math.trunc(seconds_duration),
          seconds_watched: Math.trunc(seconds_watched >= seconds_duration ? seconds_duration : seconds_watched),
      })
    }
  },
  mutations: {
    SET_MODULE(state, module) {
      state.current = module
    },
    SET_ACCESSING_CONTENT(state, value) {
      state.accessing_content = value
    },
    SET_SELECTION_MODULES(state, payload) {
      state.selection = payload;
    },
    SET_MODULE_CONTENTS(state, contents) {
      state.current = {
        ...state.current,
        contents
      };
    },
    SHOW_MODAL_MODULE(state, payload = true) {
      if(!payload){
        this.commit('SET_MODULE', null);
      }
      state.showModalModule = payload
    },
  },
  getters: {
    accessing_content: (state) => state.accessing_content,
    activeTab: state => state.current ? state.current.activeTab : 0,
    completed_contents: (state, getters) => getters.currentModuleHasContents ? getters.currentModuleContents.filter( c => c.finished_at ) : [],
    content: (state, getters) => getters.contents.length ? getters.contents[getters.activeTab] : null,
    contents: state => state.current ? state.current.contents : [],
    countCurrentModuleCompletedContents : (state) => state.current.count_completed_contents,
    countCurrentModuleContents : state => state.current.count_contents,
    currentModuleCompletedContents: (state, getters) => getters.currentModuleHasContents ? getters.currentModuleContents.filter( c => c.finished_at ) : [],
    currentModuleContents: (state, getters) => getters.hasCurrentModule ? state.current.contents : [],
    currentModuleHasContents: (state, getters) => getters.currentModuleContents.length > 0 ? true : false,
    currentModuleIsFinished: (state, getters) => getters.countCurrentModuleCompletedContents === getters.countCurrentModuleContents,
    currentModuleProgress: (state, getters) => (getters.countCurrentModuleCompletedContents / getters.countCurrentModuleContents) * 100,
    currentModuleUncompletedContents: (state, getters) => getters.currentModuleHasContents ? getters.currentModuleContents.filter( c => !c.finished_at ) : [],
    disableModuleSelection: (state, getters) => getters.selectedSelectionModules.length == getters.selectedCycle.modules_quantity,
    hasCurrentModule: state => state.current ? true: false,
    hasSelectionModules: state => state.selection.length ? true: false,
    isLoadingModule: state => state.isLoadingModule,
    isLoadingModules: state => state.isLoadingModules,
    loadedSelectionModules: state => state.loadedSelectionModules,
    loading_modules_message: state => state.loadingMessage,
    module: state => state.current,
    selectedSelectionModules: state => state.selection.filter(m => m.selected),
    selectionModules: state => state.selection,
    show_module_menu_mobile: state => state.show_module_menu_mobile,
    studyingBlocks:(state, getters) => {
      return uniqBy(getters.studyingThemes, 'block_id').map(t => t.block);
    },
    studyingBlocksIds:(state, getters) => {
      return uniqBy(getters.studyingThemes, 'block_id').map(t => t.block_id);
    },
    studyingThemes: (state, getters) => {
      const themes = []
      getters.cycles.forEach(c=> {
        c.modules.forEach(module=> {
          if(module.type == 'theme'){
            module.finished_cycle_module = c.is_finished
            module.current_cycle_module = c.is_current
            module.cycle_status = c.is_finished ? 'finished' : c.is_current ? 'current' : 'lock'
            themes.push(module)
          }
        })
      })
      return themes
    },
    uncompleted_contents: (state, getters) => getters.currentModuleHasContents ? getters.currentModuleContents.filter( c => !c.finished_at ) : [],
    videocast_selected: (state, getters) => getters.activeTab == getters.contents.length,
    view_module_dark: state => state.view_dark,
  }
}
